import React from "react";
import { useIntl } from "@ai360/core/intl";

import { messages } from "../i18n-messages";
import { ISoilTypesFailure } from "./interfaces";

const MAX_LISTED = 10;

const getFieldLabel = ({ customerName, farmName, fieldGuid, fieldName }: ISoilTypesFailure) => {
    const names = [customerName, farmName, fieldName].filter((x) => x);
    return names.length === 0 ? fieldGuid : names.join(" / ");
};

export const SoilTypesFailureToast = ({
    failures,
}: {
    failures: ISoilTypesFailure[];
}): JSX.Element => {
    const { formatMessage } = useIntl();
    return (
        <div>
            <div>
                {formatMessage(messages.reprocessSoilTypesFailedTitle, { count: failures.length })}
            </div>
            {failures.slice(0, MAX_LISTED).map((failure) => (
                <div key={failure.fieldGuid}>
                    {getFieldLabel(failure)}
                    {failure.reason === "noSoilData" &&
                        ` - ${formatMessage(messages.reprocessSoilTypesNoSoilData)}`}
                </div>
            ))}
            {failures.length > MAX_LISTED && (
                <div>
                    {formatMessage(messages.reprocessSoilTypesMoreFailed, {
                        count: failures.length - MAX_LISTED,
                    })}
                </div>
            )}
        </div>
    );
};
